import React from "react";
import "./style.css";
import { FaCcVisa, FaMoneyCheckAlt, FaSchool } from "react-icons/fa";
import { FaGoogleScholar, FaSquareUpwork } from "react-icons/fa6";
import { MdClass } from "react-icons/md";

const OurServices = () => {
  return (
    <div className="services container">
      <div className="row align-items-center p-0">
        <div className="col-12 col-lg-5">
          <h6 className="title mb-3">Solutions for You</h6>
          <h2 className="subtitle mb-4">The Support We Provide</h2>
          <p className="description">
            Simplify your study abroad experience with our expert consultancy
            services. Schedule a free career counseling session to explore
            scholarship opportunities, financial documentation guidance, test
            preparation, visa assistance, and more. Let’s make your
            international education journey seamless!
          </p>
        </div>
        <div className="col-12 col-lg-7">
          <div className="row p-0">
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <FaCcVisa className="service-icon" />
                <h5 className="service-title mb-3">Visa Application Support</h5>
                <p className="service-description mb-0">
                  Get assistance with visa processing to ensure a smooth journey
                  abroad.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <FaSchool className="service-icon" />
                <h5 className="service-title mb-3">
                  University & College Admissions
                </h5>
                <p className="service-description mb-0">
                  Get expert guidance to simplify the college and university
                  admission process.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <MdClass className="service-icon" />
                <h5 className="service-title mb-3">Test Prep Coaching</h5>
                <p className="service-description mb-0">
                  Boost your exam performance with structured test preparation
                  classes.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <FaGoogleScholar className="service-icon" />
                <h5 className="service-title mb-3">Scholarship Guidance</h5>
                <p className="service-description mb-0">
                  Explore scholarship opportunities to ease your financial
                  burden on education.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <FaSquareUpwork className="service-icon" />
                <h5 className="service-title mb-3">Career Counseling</h5>
                <p className="service-description mb-0">
                  Receive personalized guidance to align your studies with your
                  career goals.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="service-card">
                <FaMoneyCheckAlt className="service-icon" />
                <h5 className="service-title mb-3">
                  Financial Document Assistance
                </h5>
                <p className="service-description mb-0">
                  Ensure your financial documents are in order with our expert
                  support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
